import { fetchComponentHint } from '@/modules/form/api';

// Fetch a custom hint from an api defined endpoint
export default {
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: undefined,
    },
    hint: {
      type: String,
    },
    hintEndpoint: {
      type: String,
    },
    hintEndpointTriggerValues: {
      type: Array,
    },
  },
  data() {
    return {
      hintEndpointResponse: null,
    };
  },
  computed: {
    hintEndpointURL() {
      if (!this.hintEndpoint) {
        return null;
      }
      try {
        return new URL(this.hintEndpoint, document.location.origin);
      } catch (error) {
        console.error(`hintEndpoint prop needs a valid url '${this.hintEndpoint}' at ${this.name} component`);
        return null;
      }
    },
    hintComputedValue() {
      return this.hintEndpointResponse || this.hint;
    },
  },
  methods: {
    getHintEndpointFetchContext() {
      const entity = this.$getParentEditor ? this.$getParentEditor().type || this.$getParentEditor().entity : null;
      const entityId = this.$getParentEditor ? this.$getParentEditor().id : null;
      return {
        field: this.name,
        value: this.value,
        entity,
        entityId,
      };
    },
  },
  watch: {
    value: {
      async handler(val) {
        this.hintEndpointResponse = null;

        if (!this.hintEndpointURL) {
          // No endpoint configured
          return;
        }
        if (this.hintEndpointTriggerValues && !this.hintEndpointTriggerValues.includes(this.value)) {
          // Current component value is not included in hintEndpointTriggerValues
          return;
        }

        const { hint } = await fetchComponentHint(this.hintEndpointURL.href, this.getHintEndpointFetchContext());
        if (typeof hint === 'undefined') {
          console.error(`hintEndpoint '${this.hintEndpoint}' response json needs a hint field at ${this.name} component`);
        }
        this.hintEndpointResponse = hint;
      },
      immediate: true,
    },
  },
};
